import type { ReportRequest } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Toggle,
  Label,
  InfoButton,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEventHandler } from "react"
import { useCallback } from "react"
import styles from "./Reports.module.scss"
import { usePolyglot } from "src/contexts"

const id = "show-photos-input-id"
const polyglotPrefix = "pages.settings.generate_report.show_photos."

interface Props {
  reportRequest: ReportRequest;
  updateReportRequest: (reportRequest: Partial<ReportRequest>) => void;
}

export function ShowPhotosToggle(props: Props) {
  const {
    updateReportRequest,
    reportRequest,
  } = props

  const polyglot = usePolyglot()

  const onChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      updateReportRequest({
        show_photos: e.target.checked,
      })
    },
    [updateReportRequest],
  )

  return (
    <div className={styles.toggleRow}>
      <Label
        htmlFor={id}
        id="show-photos"
      >
        {polyglot.t(`${polyglotPrefix}label`)}
        <InfoButton title={polyglot.t(`${polyglotPrefix}info_title`)}>
          {polyglot.t(`${polyglotPrefix}info_description`)}
        </InfoButton>
      </Label>
      <Toggle
        checked={reportRequest.show_photos}
        onChange={onChange}
        id={id}
      />
    </div>
  )
}
